import HttpService from '@src/utility/httpService';
import { checkIsInternal } from '@src/utility/createStorage';
import { config } from '@uhg-abyss/web/tools/config';
const _httpService = new HttpService();

if (checkIsInternal()) {
  _httpService.setBaseURL(config('API_DOMAIN_INTERNAL'));
} else {
  _httpService.setBaseURL(config('API_DOMAIN_EXTERNAL'));
}

export const getPSMSPaymentIntegritySummaryData = (payload: any) => {
  const fetchData = async () => {
    try {
      const response: any = await _httpService.push('payment-integrity/evaluations/', payload);
      return response;
    } catch {
      return null;
    }
  };
  return fetchData();
};

export const getPSMSEvaluationDetails = (payload: any) => {
  // Exclude fields not required by the evaluation details API.
  const { TimeFilter, TimeFilterText, ...evaluationDetailsPayload } = payload ?? {};
  const fetchData = async () => {
    try {
      const response: any = await _httpService.push(
        '/payment-integrity/evaluation-details/?request-type=ANNUAL',
        evaluationDetailsPayload
      );
      return response;
    } catch {
      return null;
    }
  };
  return fetchData();
};

export const getAuditReasonCodes = (payload: any) => {
  const fetchData = async () => {
    try {
      const response: any = await _httpService.push(
        '/payment-integrity/audit-reason-details/',
        payload
      );
      return response;
    } catch {
      return null;
    }
  };
  return fetchData();
};
